import TextField from '../TextField'
import EmailField from '../EmailField'
import SelectField from '../SelectField'
import CheckboxField from '../CheckboxField'
import RadioboxField from '../RadioboxField'
import CheckboxMultipleField from '../CheckboxMultipleField'
import MultiSelectField from '../MultiSelectField'
import TextareaField from '../TextareaField'
import ExpandableTableField from '../ExpandableTableField'
import NumberField from '../NumberField'
import DateField from '../DateField'
import PhoneNumberField from '../PhoneNumberField'
import CustomField from '../CustomField'
import FileUpload from '../FileUpload'
import TableField from '../TableField'
import MobileotpField from 'components/MobileotpField'
import AutocompleteField from 'components/AutocompleteField'
import SelectAllField from 'components/SelectAllField'

import PasswordField from '../PasswordField'
import TransportDetailField from '../TransportDetailField'
import TimeField from 'components/TimeField'
import ChooseOptionField from '../ChooseOptionField'
import QuestionRadioboxField from '../QuestionRadioboxField'
import MobileField from 'components/MobileField/MobileField'
import TextOnlyField from 'components/TextOnlyField'
import ZipCodeField from 'components/ZipCode'
import CodeField from 'components/CodeField'
import DateFieldMultiple from 'components/DateFieldMultiple'
import FilterSelectField from 'components/FilterSelectField'
import FilterMultiSelectField from 'components/FilterMultiSelectField'
import EmployeeMultiSelect from 'components/EmployeeMultiSelect'
import EmployeeCheckboxField from 'components/EmployeeCheckbox'
import DateMultiSelect from 'components/DateMultiSelect'

export const ImplementationFor = {
    text: TextField,
    select: SelectField,
    checkbox: CheckboxField,
    checkboxmultiple: CheckboxMultipleField,
    radio: RadioboxField,
    hrmsCheckbox: EmployeeCheckboxField,
    multiSelect: MultiSelectField,
    employeeMultiSelect: EmployeeMultiSelect,
    selectAll: SelectAllField,
    textarea: TextareaField,
    dateMultiple: DateFieldMultiple,
    filterSelect: FilterSelectField,
    filterMultiSelect: FilterMultiSelectField,
    customTable: ExpandableTableField,
    number: NumberField,
    date: DateField,
    phone: PhoneNumberField,
    code: CodeField,
    textOnly: TextOnlyField,
    mobile: MobileField,
    zipCode: ZipCodeField,
    email: EmailField,
    upload: FileUpload,
    custom: CustomField,
    table: TableField,
    mobileotp:MobileotpField,
    autocomplete: AutocompleteField,
    password:PasswordField,
    transportDetail:TransportDetailField,
    time: TimeField,    
    chooseOption:ChooseOptionField,
    questionRadioboxField:QuestionRadioboxField,
    dateMultiSelect:DateMultiSelect
}

